import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

import { getComplaints as getComplaintsApi, changeComplaintStatusApi } from "../../helpers/api/complaints";

import { ComplaintsActionTypes } from "./constants";
import { getComplaints, ComplaintsApiResponseSuccess, ComplaintsApiResponseError } from "./actions";
import { MAX_ITEMS_PER_PAGE } from "../../helpers/api/apiCore";

function* getComplaintsSaga({ payload: { issueType, status, page, limit } }: any): SagaIterator {
  try {
    const response = yield call(getComplaintsApi, issueType, status, page, limit);
    const data = response?.data?.data;

    yield put(ComplaintsApiResponseSuccess(ComplaintsActionTypes.GET_COMPLAINTS, data));
  } catch (error: any) {
    yield put(ComplaintsApiResponseError(ComplaintsActionTypes.GET_COMPLAINTS, error));
  }
}

function* changeComplaintStatusSaga({ payload: { complaintId, status } }: any): SagaIterator {
  try {
    const response = yield call(changeComplaintStatusApi, { complaintId, status });
    const message = response?.data?.message;

    yield put(ComplaintsApiResponseSuccess(ComplaintsActionTypes.CHANGE_STATUS, message));
    yield put(getComplaints(undefined, undefined, 1, MAX_ITEMS_PER_PAGE));
  } catch (error: any) {
    yield put(ComplaintsApiResponseError(ComplaintsActionTypes.CHANGE_STATUS, error));
  }
}

export function* watchGetComplaints() {
  yield takeEvery(ComplaintsActionTypes.GET_COMPLAINTS, getComplaintsSaga);
}

export function* watchChangeComplaintStatus() {
  yield takeEvery(ComplaintsActionTypes.CHANGE_STATUS, changeComplaintStatusSaga);
}

function* ComplaintsSaga() {
  yield all([fork(watchGetComplaints), fork(watchChangeComplaintStatus)]);
}

export default ComplaintsSaga;
